import React, { useState } from 'react';
import Select from 'react-select';
import {
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  Input,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
} from 'reactstrap';
import DatePicker from 'react-datepicker';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import Translate, { t, translateDate } from '../../common/Translate';
import { useEditAppointment } from '../../../hooks/useCalendar/useRecordBlocs/useEditAppointment';
import caleandarIcon from '../../../assets/img/calendar.svg';
import { Auth } from '../../../config/configuration/react';
import MeetingTag from '../MeetingTag';
import { REACT_APP_API } from '../../../config';

export const EditAppointmentModal = ({
  recordId,
  concessionId,
  concessionName,
  appointmentDateTime,
  isOpen,
  toggle,
  records,
  role,
  recordTypeId,
  counterInspection,
  showModelCounterInspaction,
}) => {
  const [selectedOptionSource, setSelectedOptionSource] = useState(null);

  const {
    edit,
    timeOptions,
    concessionOptions,
    setSelectedTime,
    setSelectedDate,
    setSelectedConcessionId,
    selectedDate,
    error,
    isError,
    isValid,
    cancelAppointment,
    cancelIsAllowed,
    counterInspectionRecordId,
    toggleCheck,
    pointOfSaleListLoading,
    handleScroll,
    toggleDropdown,
    dropdownOpen,
    searchConcession,
    searchText,
    setSearchText,
  } = useEditAppointment({
    recordId,
    concessionId,
    concessionName,
    appointmentDateTime,
    toggle,
    counterInspection,
    recordTypeId,
  });

  const mappedSourceData = concessionOptions?.map((item) => {
    return { value: item.id, label: item.name };
  });

  const country = Auth.country()?.toLowerCase();
  const fileName = country === 'ES' ? 'informe_estadoVO' : 'rapport_d_inspection';

  const modalBody = () => (
    <>
      <p className="modal-p">{t('popUpLicensePlateRecognized2')}</p>
      <div className="overflow-auto mt-2 mb-2">
        <table className="modal-table">
          <thead className="modal-table-thead">
            <tr>
              <td>{t('file_number')}</td>
              <td>{t('creation_date')}</td>
              <td>{t('status')}</td>
              <td>{t('pointOfSaleName')}</td>
              <td>{t('buyer')}</td>
              <td>{t('offer')}</td>
              <td>{t('appraisalLinked')}</td>
              <td>{t('pdf')}</td>
            </tr>
          </thead>
          <tbody>
            {_.map(records, (r) => (
              <tr key={r.recordId} className="modal-table-tr">
                <td className="modal-table-td">
                  {['manager', 'admin', 'superAdmin', 'multiSupervisor'].includes(role) ||
                  (['buyer', 'supervisor'].includes(role) && Auth.concessionIds().includes(r.concessionCarcheckId)) ? (
                    <Link to={`/files/${r.recordId}`} target="_blank">
                      <u>{r.refHexaId}</u>
                    </Link>
                  ) : (
                    r.refHexaId
                  )}
                </td>
                <td className="modal-table-td">{translateDate(r.createdAt.date, 'DD-MM-YYYY')}</td>
                <td className="modal-table-td">
                  <MeetingTag code={r.statusCarcheck} />
                </td>
                <td className="modal-table-td">{r.concessionName}</td>
                <td className="modal-table-td">{r.buyerFullName}</td>
                <td className="modal-table-td">{_.round(r.c2bOffer)}</td>
                <td className="modal-table-td">
                  <input
                    id="appraisalLinked"
                    name="appraisalLinked"
                    checked={counterInspectionRecordId === r.recordId}
                    onChange={(e) => toggleCheck(e, r.recordId)}
                    type="checkbox"
                  />
                </td>
                <td className="modal-table-td">
                  {['manager', 'admin', 'superAdmin', 'multiSupervisor'].includes(role) ||
                  (['buyer', 'supervisor'].includes(role) && Auth.concessionIds().includes(r.concessionCarcheckId)) ? (
                    <a
                      target="_blank"
                      href={`${REACT_APP_API}/buyer/public/${r.sourceLabel}/${r.recordKey}/admin-documents/${r.recordId}_${fileName}.pdf`}
                      rel="noopener noreferrer"
                    >
                      <u>{t('seeReport')}</u>
                    </a>
                  ) : (
                    ''
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
  const handleChange = (e) => {
    setSelectedConcessionId(e?.value);
    setSelectedOptionSource(e);
    toggleDropdown();
  };

  let toggleText = '';
  if (selectedOptionSource || concessionName) {
    toggleText = selectedOptionSource?.label || concessionName;
  } else {
    toggleText = `${t('select')}`;
  }
  return (
    <Modal isOpen={isOpen} toggle={toggle} size={(showModelCounterInspaction && 'lg') || 'md'}>
      <ModalHeader toggle={toggle} className="model-title">
        {!showModelCounterInspaction && (
          <>
            <img src={caleandarIcon} alt="" className="calendar-icon" />
            {t('update_meeting')}
          </>
        )}
        {showModelCounterInspaction && counterInspection?.recordId && t('modifyAssociation')}
        {showModelCounterInspaction && !counterInspection?.recordId && t('addAssociation')}
      </ModalHeader>
      <ModalBody>
        {(showModelCounterInspaction && modalBody()) || (
          <Row className="mb-4">
            <Col xs="12" key="meetingDate">
              <Label className="mb-2 text-primary text-left" for="meetingDate">
                <Translate code="meetingDate" />
              </Label>
              <DatePicker
                className="form-control rounded icon-calendar"
                name="meetingDate"
                id="meetingDate"
                onChange={setSelectedDate}
                selected={selectedDate}
                locale={t('language')}
                dateFormat={t('dd.MM.yyyy')}
                placeholderText={t('date_placeholder')}
                autoComplete="off"
              />
            </Col>
            <Col xs="12" key="meetingTime">
              <Label className="mb-2 text-primary text-left" for="meetingTime">
                <Translate code="meetingTime" />
              </Label>
              <Input
                className="form-control rounded icon-chevron-down"
                type="select"
                name="configAppointementDate"
                id="configAppointementDate"
                onChange={(e) => setSelectedTime(e.target.value)}
                value={timeOptions.filter((option) => option.selected === true)?.[0]?.time}
              >
                <option value="0">{`${t('select')}`}</option>
                {timeOptions.map((option) => (
                  <option key={option.time} value={option.time}>
                    {option.time}
                  </option>
                ))}
              </Input>
            </Col>
            <Col xs="12" key="meetingPointOfSale">
              <Label className="mb-2 text-primary text-left" for="meetingPointOfSale">
                <Translate code="meetingPointOfSale" />
              </Label>
              <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown} onScroll={handleScroll}>
                <DropdownToggle
                  caret
                  className="display-point-of-sale form-control drop-down-pos rounded icon-chevron-down"
                  data-testid="meetingPointOfSale"
                  id="meetingPointOfSale"
                >
                  {toggleText}
                </DropdownToggle>
                <DropdownMenu style={{ width: '100%' }}>
                  <Select
                    value={{ label: searchText, value: searchText }}
                    inputValue={searchText}
                    onChange={handleChange}
                    options={mappedSourceData}
                    isSearchable
                    menuIsOpen
                    isLoading={pointOfSaleListLoading}
                    onInputChange={(value, action) => {
                      if (action.action === 'input-change') {
                        setSearchText(value);
                        searchConcession(value);
                      }
                    }}
                  />
                </DropdownMenu>
              </Dropdown>
            </Col>
            {isError && (
              <p className="ml-2 text-danger">
                <Translate code={error} />
              </p>
            )}
          </Row>
        )}
        <button
          type="button"
          className="btn btn-block btn-1"
          onClick={edit}
          disabled={!isValid || pointOfSaleListLoading}
        >
          {t('confirm')}
        </button>
        {cancelIsAllowed && recordTypeId === 1 && (
          <button type="button" className="btn btn-block btn-3" onClick={cancelAppointment}>
            {t('cancel_appointment')}
          </button>
        )}
      </ModalBody>
    </Modal>
  );
};

EditAppointmentModal.propTypes = {
  recordId: PropTypes.number.isRequired,
  concessionId: PropTypes.number,
  concessionName: PropTypes.string,
  appointmentDateTime: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  records: PropTypes.oneOfType([PropTypes.array, PropTypes.shape()]).isRequired,
  role: PropTypes.string.isRequired,
  recordTypeId: PropTypes.number.isRequired,
  counterInspection: PropTypes.oneOfType([PropTypes.array, PropTypes.shape()]).isRequired,
  showModelCounterInspaction: PropTypes.bool.isRequired,
};

EditAppointmentModal.defaultProps = {
  concessionId: null,
  appointmentDateTime: '',
  concessionName: '',
};
